import { defineStore } from 'pinia'

import { useNotificationStore } from '@/stores/helpers/notification.js'
import NotificationDeviceService from '@/services/retailer/NotificationDeviceService.js'
import i18n from '@/i18n/i18n.js'



const { t } = i18n.global

export const useNotificationDeviceStore = defineStore('retailerNotificationDevice', () => {
  const notificationStore = useNotificationStore()

  const createNotificationDevice = notificationDevice => {
    return new Promise((resolve, reject) => {
      NotificationDeviceService.createNotificationDevice(notificationDevice)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.create_error', {
              element: t('views.retailer.notifications.notification')
            })
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  return {
    createNotificationDevice
  }
})
